import React, { useEffect } from 'react';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import Person2Icon from '@mui/icons-material/Person2';
import PropTypes from 'prop-types';
import { useLocation, Link } from 'react-router-dom';

const PlaylistHoverModalMobile = ({ 
  video, 
  formattedDuration, 
  selectedTags, 
  selectTagCallback, 
  onClose ,
  handlePlay
}) => {
  
  // Handle ESC key close
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [onClose]);

  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
      style={{
        backgroundColor: 'rgba(0,0,0,0.4)',
        backdropFilter: 'blur(6px)',
        zIndex: 1050
      }}
      onClick={onClose} // close when clicking outside
    >
      {/* Modal content wrapper */}
      <div
        className=" rounded p-1 position-relative"
        style={{ backgroundColor:"#27272A",width: '80%', maxWidth: '300px' }}
        onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
      >
        {/* Thumbnail */}
        <div className="position-relative mb-2">
          <img
            src={video?.thumnailLink}
            alt={video?.title}
            className="img-fluid rounded w-100"
            style={{ maxHeight: '200px', objectFit: 'cover' }}
          />

          {/* Bottom overlay */}
          <div
            className="position-absolute bottom-0 start-0 w-70 d-flex gap-2 p-1"
            style={{ fontSize: '12px' }}
          >
            <span
              className="bg-black text-white rounded" style={{padding:"4px 6px"}}
            >
              {formattedDuration}
            </span>

            {video?.instructor && (
              <span
                className="bg-black text-white rounded d-flex align-items-center text-truncate"
                style={{ maxWidth: "70%" ,padding:"4px 6px", gap:"0.1rem"}}
              >
                <Person2Icon fontSize="small" />
                {video?.instructor}
              </span>
            )}
          </div>
        </div>

        {/* Title */}
        <h5 className="playlist_name text-white">{video?.title}</h5>

        {/* Tags */}
        <div className="d-flex flex-wrap gap-1 mt-1">
          <Tags
            tags={video?.tagsDetails || video?.tagsData || video?.tags || []}
            selectedTags={selectedTags}
            selectTagCallback={selectTagCallback}
          />
        </div>

        {/* Play button */}
        <div className="mt-1 d-flex justify-content-center">
          <button className="common-plan-button" onClick={handlePlay}>
            <PlayArrowIcon fontSize="small" />
            <span>Play</span>
            
          </button>
        </div>
      </div>
    </div>
  );
};

export const Tags = ({ tags, selectedTags, selectTagCallback }) => {
  const { pathname } = useLocation();

  console.log('====================================');
  console.log(pathname.indexOf('Lessons'),
    pathname.indexOf('Exercises'),
    pathname.indexOf('AcrosstheFloor'),
    pathname.indexOf('AllVideos'));
  console.log('====================================');

  // Check if in library view
  let inLibraryView = true;
  if (
    pathname.indexOf('Lessons') === -1 &&
    pathname.indexOf('Exercises') === -1 &&
    pathname.indexOf('Acrossthefloor') === -1 &&
    pathname.indexOf('AllVideos') === -1
  ) {
    inLibraryView = false;
  }

  if (!tags || tags.length === 0) return null;

  return (
    <div className="c-video_tag">
      <ul>
        {[...tags]
          .sort((a, b) => a?.priority - b?.priority)
          .map((tag, index) => (
            <li
              key={tag?._id || index}
              className="c-video_tag-entry-playlist"
              style={{
                background: tag?.color,
                borderColor: selectedTags?.includes(tag._id) ? 'black' : 'transparent',
                color: selectedTags?.includes(tag._id) ? 'black' : 'white',
                padding:"4px 6px"
              }}
              onClick={e => {
                e.stopPropagation();
                if (selectTagCallback) {
                  selectTagCallback(tag);
                }
              }}
            >
              {!inLibraryView ? <Link to={`/AllVideos?tag=${tag?._id}`}>{tag?.name}</Link> : tag?.name}
            </li>
          ))}
      </ul>

    </div>
  );
};

Tags.propTypes = {
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string,
      name: PropTypes.string,
      color: PropTypes.string,
      priority: PropTypes.number
    })
  )
};

export default PlaylistHoverModalMobile;
